import { useMemo } from 'react';
import { useEventsQuery } from '../generated/graphql';

export const useRsvpOncount = (): number => {
  const { data } = useEventsQuery();

  return useMemo(() => {
    return (
      data?.events?.reduce((i, e) => {
        if (e?.requireRsvp === true) {
          i += 1;
        }

        return i;
      }, 0) || 0
    );
  }, [data]);
};
